module.exports = __webpack_public_path__ + "img/Imagenes_green_camera.1eeb3480.png";